import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import _ from 'lodash';
import { SelectOptionsInterface } from '../../interfaces/common.interface';
import { initFlowbite } from 'flowbite';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'app-select-search',
  templateUrl: './select-search.component.html',
  styleUrls: ['./select-search.component.css'],
  host: {
    '(document:click)': 'closeDropDown($event)',
  },
})

/**
 * Select Search Reusable Component
 */
export class SelectSearchComponent implements OnInit {
  @Output() optionChangeEmitter = new EventEmitter<SelectOptionsInterface>();
  public searchKeyword!: string;
  public toggleListing!: boolean;
  public selectedOption!: SelectOptionsInterface;
  public initialPlaceholder!: string;
  public label!: string;
  public placeholder!: string;
  public items!: Array<SelectOptionsInterface>;
  public filteredItems!: Array<SelectOptionsInterface>;
  public enableError!: boolean;
  public loader!: boolean;
  public showSearchBox!: boolean;
  @Input() class: any;
  @Input() isFloating: boolean = true;

  /**
   * @constructor
   */
  constructor(
    public _eref: ElementRef,protected router : Router
  ) {
    this.selectedOption = { value: '', displayText: '', _id: '', id: 0 }
  }

  /**
   * called initially
   */
  ngOnInit(): void {
       this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
           setTimeout(() => {  initFlowbite();})
          }
        });
    initFlowbite();
    this.loader = false;
    this.toggleListing = false;
  }

  /**
   * On select change pre-process
   *
   * @param {string} value
   */
  public onSelectPreProcess(value: string): void {
    this.selectedOption = _.find(this.items, { value })!;
    this.toggleListing = false;
    this.searchKeyword = '';
  }

  /**
   * on click dropdown
   */
  public clickDropdown() {
    this.toggleListing = !this.toggleListing;
  }

  /**
   * Triggered when click outside a element
   *
   * @param {Event} event
   */
  public closeDropDown(event: Event): void {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.toggleListing = false;
    }
  }

  /**
   * Clear selected option
   */
  public clearSelectedOption(): void {
    this.selectedOption = { value: '', displayText: '', _id: '', id: 0 };
  }

  /**
   * @param {string} value
   */
  onSelectChange(value: string) {

  }

  /**
 *search country codes
 @param{any}event
 */
  searchCountries(event: any) {
    console.log(event)
    const searchText = event.target.value;

    this.filteredItems = this.items.filter(country => country.displayText.toLowerCase().includes(searchText.toLowerCase()));


  }

}
